document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.svg-icon').forEach(function(img) {
        var imgID = img.id;
        var imgClass = img.className;
        var imgURL = img.src;

        fetch(imgURL).then(function(response) {
            return response.text();
        }).then(function(text) {
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(text, "text/xml");
            var svg = xmlDoc.getElementsByTagName('svg')[0];

            if (imgID) {
                svg.id = imgID;
            }

            if (imgClass) {
                svg.setAttribute('class', imgClass + ' replaced-svg');
            }

            svg.removeAttribute('xmlns:a');

            img.parentNode.replaceChild(svg, img);
        }).catch(function(error) {
            console.error(error);
        });
    });
});